import type { CronJob } from '@/frontend/pages/Dashboard/DigitalWorkers/types'
import { cronToSchedule, cronToSummaryPtBR } from '@/frontend/utils/scheduleCronHelpers'

export type BadgeVariant = 'success' | 'critical' | 'warning' | 'info'

export interface StatusBadgeInfo {
  variant: BadgeVariant
  label: string
}

export function formatInterval(ms: number): string {
  const minutes = Math.round(ms / 60_000)
  if (minutes < 60) return `A cada ${minutes} min`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `A cada ${hours}h`
  const days = Math.round(hours / 24)
  return `A cada ${days}d`
}

export function formatTimestamp(ms: number): string {
  return new Date(ms).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatShortTimestamp(ms: number): string {
  return new Date(ms).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatSchedule(job: CronJob): string {
  if (job.schedule.kind === 'at' && job.schedule.at) {
    return `Uma vez em ${formatShortTimestamp(Date.parse(job.schedule.at))}`
  }
  if (job.schedule.kind === 'every' && job.schedule.everyMs) {
    return formatInterval(job.schedule.everyMs)
  }
  if (job.schedule.kind === 'cron' && job.schedule.expr) {
    return cronToSummaryPtBR(job.schedule.expr)
  }
  return job.schedule.kind
}

export function formatTimeOfDay(job: CronJob): string | null {
  if (job.schedule.kind === 'cron' && job.schedule.expr) {
    return cronToSchedule(job.schedule.expr)?.timeOfDay ?? null
  }
  return null
}

export function getStatusBadgeInfo(status: string | null): StatusBadgeInfo {
  if (status === 'ok') return { variant: 'success', label: 'OK' }
  if (status === 'error') return { variant: 'critical', label: 'Erro' }
  if (status === 'skipped') return { variant: 'warning', label: 'Pulada' }
  return { variant: 'info', label: 'Nunca executada' }
}
